import type { ShowcaseProductsParams } from '~/api/data-source/showcase';
import { showcaseRepository } from '~/api/repository/showcase';

export const SHOWCASE_QUERY_KEY = {
  all: ['showcase'] as const,

  // 쇼케이스 그룹 메타 (이름/이미지/쇼케이스 탭 목록)
  group: (showcaseGroupCode: string) => ({
    queryKey: [
      '/api/market-place/v1/showcase-groups/{showcaseGroupCode}',
      showcaseGroupCode,
    ] as const,
    queryFn: () => showcaseRepository.getShowcaseGroup(showcaseGroupCode),
  }),

  // 쇼케이스 상품 목록 (무한 스크롤, 커서 페이지네이션)
  products: (params: ShowcaseProductsParams) => ({
    queryKey: ['/api/market-place/v4/showcases', params] as const,
    queryFn: ({ pageParam }: { pageParam?: string[] } = {}) =>
      showcaseRepository.getShowcaseProducts({
        ...params,
        searchAfter: pageParam,
      }),
    infinite: true,
  }),
};
